export enum StatusEnum {
    UNPAIRED = 'UNPAIRED',
    PAIRED = 'PAIRED',
    UNASSIGNED = 'UNASSIGNED'
}
